import { useEffect, useState } from "react";

import { getSiteNotice, type SiteNotice } from "./api";

function shouldShowNotice(notice: SiteNotice | null) {
  if (!notice?.enabled || !notice.notice_id || !notice.body) {
    return false;
  }
  return true;
}

export function SiteNoticeBar() {
  const [notice, setNotice] = useState<SiteNotice | null>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void getSiteNotice()
      .then((nextNotice) => {
        if (cancelled) {
          return;
        }
        setNotice(nextNotice);
        setVisible(shouldShowNotice(nextNotice));
      })
      .catch(() => {
        if (!cancelled) {
          setVisible(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!visible || !notice?.notice_id || !notice.body) {
    return null;
  }

  const dismiss = () => {
    setVisible(false);
  };

  return (
    <aside className={`site-notice site-notice--${notice.tone}`} aria-label="Site announcement">
      <div className="site-notice__inner">
        <div className="site-notice__icon" aria-hidden="true">
          <span>!</span>
        </div>
        <div className="site-notice__copy">
          {notice.title ? <strong>{notice.title}</strong> : null}
          <span>{notice.body}</span>
        </div>
        {notice.cta_label && notice.cta_url ? (
          <a className="site-notice__cta" href={notice.cta_url}>
            {notice.cta_label}
          </a>
        ) : null}
        <button className="site-notice__close" type="button" onClick={dismiss} aria-label="Dismiss announcement">
          x
        </button>
      </div>
    </aside>
  );
}
